import * as React from 'react';

/** Radix's Slot concatenates `aria-describedby` instead of letting a child override it, so the prop can only be dropped here. */
export const UndescribedSpan = React.forwardRef<HTMLSpanElement, React.ComponentProps<'span'>>(
  function UndescribedSpan({ 'aria-describedby': _, ...props }, ref) {
    return <span ref={ref} {...props} />;
  },
);
